import global from 'global';
import { assign, identity } from 'lodash';
import { ACCEPT, CONTENT_TYPE } from 'http-header-fields';

const negotiate = ({ body }) => {
  const headers = {
    [ACCEPT]: 'application/json',
  };

  const isFormData = global.FormData && body instanceof global.FormData;

  if (!isFormData) {
    headers[CONTENT_TYPE] = 'application/json; charset=utf-8';
  }

  return headers;
};

export default () => ({ options }) => {
  assign(options.headers, {
    ...negotiate(options),
    ...options.headers,
  });

  return identity;
};



// WEBPACK FOOTER //
// ./src/Api/middleware/negotiate.js